import { useQuery } from '@tanstack/react-query';
import { workflowApiClient } from 'src/api/FiretrolApiClientInstances';
import { queryKeys } from 'src/api/queries/queryKeys';
import { toCancelToken } from 'src/api/queries/queryClient';

export function useWorkflowOptionsByDivision(
  divisionId: number | null | undefined,
  resourceId: string,
) {
  return useQuery({
    queryKey: queryKeys.workflows.optionsByDivision(
      divisionId ?? -1,
      resourceId,
    ),
    queryFn: ({ signal }) =>
      workflowApiClient.getWorkflowOptionsByDivision(
        divisionId!,
        resourceId,
        toCancelToken(signal),
      ),
    enabled: divisionId != null && divisionId > 0,
    staleTime: 60_000,
    meta: { errorContext: 'division workflow options' },
  });
}
